import { FieldError } from 'react-hook-form';

export interface Rules {
  type?: 'text' | 'date' | 'url' | 'number' | 'password' | 'email';
  minLength?: number | null;
  maxLength?: number | null;
  min?: number;
  max?: number;
}

export const REQUIRED_ERROR_MESSAGE = 'This field is required.';

export const getErrorMessage = (
  error?: FieldError,
  obj?: Rules,
  customMessages?: {
    email?: string;
    maxLength?: string;
    minLength?: string;
    min?: string;
    max?: string;
    notMinExclusive?: string;
    notMaxExclusive?: string;
  },
) => {
  if (error) {
    switch (error.type) {
      case 'required':
        return REQUIRED_ERROR_MESSAGE;
      case 'minLength':
        return customMessages?.minLength || `Min. ${obj?.minLength} characters.`;
      case 'maxLength':
        return customMessages?.maxLength || `Max. ${obj?.maxLength} characters.`;
      case 'min':
        return customMessages?.min || `Min value is ${obj?.min}.`;
      case 'max':
        return customMessages?.max || `Max value is ${obj?.max}.`;
      case 'notMinExclusive':
        return customMessages?.notMinExclusive || `Value must be greater than ${obj?.min}.`;
      case 'notMaxExclusive':
        return customMessages?.notMaxExclusive || `Value must be less than ${obj?.max}.`;
      case 'pattern':
        switch (obj?.type) {
          case 'text':
            return 'Cannot contain only blank characters.';
          case 'url':
            return 'Must be a valid URL.';
          case 'number':
            return 'Must be a valid number.';
          case 'email':
            return customMessages?.email || 'Invalid email address.';
          default:
            return 'Must be valid.';
        }
      default:
        return error.message;
    }
  }
  return '';
};
